<nb-select [placeholder]="placeholder" fullWidth>
  <nb-option *ngFor="let option of options" [value]="option.value">{{ option.labelTranslationKey | translate }}</nb-option>
</nb-select>
